if (!customElements.get('responsive-disclosure')) {
	customElements.define(
		'responsive-disclosure',
		class ResponsiveDisclosure extends HTMLElement {
			constructor() {
				super()

				this.element = this.querySelector('details')

				if (!this.element) {
					return
				}

				this.setDefaultState()
				this.setEventListeners()
			}

			/**
			 * Sets the event listeners.
			 */
			setEventListeners() {
				window.addEventListener('resize', throttle(this.setDefaultState.bind(this)))
			}

			/**
			 * Sets the default state of the disclosure element.
			 */
			setDefaultState() {
				this.element.open = !this.isMobile()
			}

			/**
			 * Returns if we're on mobile.
			 */
			isMobile() {
				return window.matchMedia('(max-width: 989px)').matches
			}
		}
	)
}
